module.exports = __webpack_public_path__ + "img/supplier_avatar.b3936a15.png";